import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom"
import "@/assets/sass/project.scss"
import Project from "./components/project.jsx"
import RegistrationGuide from "./components/Registration-Guide.jsx"
import { useEffect, useState } from "react";
import Store from "@/store"
const NextIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.1332 7.98372L5.0332 4.88372L6.26654 3.65039L10.5999 7.98372L6.26654 12.3171L5.0332 11.0837L8.1332 7.98372Z" fill="#576059" />
</svg>

export default function Index() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState(0)
  const language = Store.getState().language
  useEffect(() => {
    let activesTargets = []
    let navs = [], targets = []
    const observer = new IntersectionObserver((entries) => {
      let doms = Array.from(targets)
      if (!doms) return
      entries.forEach(item => {
        if (item.isIntersecting) {
          doms.find(self => self === item.target).active = true
        } else if (item.intersectionRatio === 0) {
          doms.find(self => self === item.target).active = false
        }
      })
      activesTargets = doms.filter(item => item.active)
      if (activesTargets[0]) {
        navs.forEach(item => (item.getAttribute('target') === activesTargets[0].id) ? item.classList.add('active') : item.classList.remove('active'))
      }
    }, { root: null, threshold: 0, rootMargin: '-78px 0px 0px 0px' });
    if (activeTab == 1) {
      navs = document.querySelectorAll('.anchor-group .item')
      targets = document.querySelectorAll('.projecttarget')
      targets.forEach(item => observer.observe(item))
    } else {
      targets.forEach(item => observer.unobserve(item))
    }
    return () => observer.disconnect()
  }, [activeTab, language])
  const toView = (id) => {
    document.querySelector(id).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <div className="project-page">
    <div dangerouslySetInnerHTML={{ __html: "<style>html,body{height:100%}</style>" }}></div>
    <section className="cs-page_head cs-bg" style={{ backgroundImage: "url(/assets/img/projectbg.jpg)", height: "338px", display: "flex", alignItems: "center" }} >
      <div className="container">
        <div className="text-center">
          <h1 className="cs-page_title gmarket" style={{ position: "relative", fontSize: 40, color: "white", fontWeight: 'bold', 'text-transform': "uppercase" }}>
            {t('project.project')}
          </h1>
        </div>
      </div>
    </section>
    <div className="project-container container">
      <div className="left-sticky">
        <div className="navs-menus">
          <div className="title"> {t('project.project')}</div>
          <ul className="navs-list">
            <li className={"navs-item " + (activeTab == 0 ? 'active' : '')} onClick={() => setActiveTab(0)}>
              <div className="navs-label">
                <span>{t('project.project')}</span>
                <NextIcon />
              </div>
            </li>
            <li className={"navs-item " + (activeTab == 1 ? 'active' : '')} onClick={() => setActiveTab(1)}>
              <div className="navs-label">
                <span>{t('project.registration_guide')}</span>
                <NextIcon />
              </div>
            </li>
          </ul>
          <div className="content">
          </div>
        </div>
        {activeTab == 1 && <div className="anchor-group">
          <div className="item" target="projecttarget1" onClick={() => toView("#projecttarget1")}>{t('project.registration_guide_title1')}</div>
          <div className="item" target="projecttarget2" onClick={() => toView("#projecttarget2")}>{t('project.registration_guide_title2')}</div>
          <div className="item" target="projecttarget3" onClick={() => toView("#projecttarget3")}>{t('project.registration_guide_title3')}</div>
          <div className="item" target="projecttarget4" onClick={() => toView("#projecttarget4")}>{t('project.registration_guide_title4')}</div>
          <div className="item" target="projecttarget5" onClick={() => toView("#projecttarget5")}>{t('project.registration_guide_title5')}</div>
          <div className="item" target="projecttarget6" onClick={() => toView("#projecttarget6")}>{t('project.registration_guide_title6')}</div>
        </div>}

      </div>
      <div className="page-content">
        {activeTab == 0 && <Project />}
        {activeTab == 1 && <RegistrationGuide />}
      </div>
    </div>
  </div>
}